import React from 'react';

function AdminServices() {
    return <div>AdminServices</div>;
}

export default AdminServices;
